import React from "react";
import Button, { ButtonTypes } from "../../../../components/Button";

import { RetryNoteProps } from "./types";

export const RetryNote: React.FC<RetryNoteProps> = ({ message, onRetry }) => (
  <>
    {message}{" "}
    <Button type={ButtonTypes.link} size="small" underline onClick={onRetry}>
      Try again
    </Button>
  </>
);
